import { AppContext } from '@contexts'
import { USER_ACTIONS, IUserProfile } from '@contexts/userReducer/model.d'
import { useContext } from 'react'

const useUserDispatcher = () => {
    const { dispatch } = useContext(AppContext)

    const setTokenAuthData = (token: string) => {
        dispatch({
            type: USER_ACTIONS.SET_TOKEN_AUTH_DATA,
            payload: { token }
        })
    }

    const clearUserAuthData = () => {
        dispatch({
            type: USER_ACTIONS.CLEAR_USER_AUTH_DATA,
            payload: null
        })
    }

    const setAdminProfile = (userProfile: IUserProfile) => {
        dispatch({
            type: USER_ACTIONS.SET_USER_ADMIN_PROFILE,
            payload: { userProfile }
        })
    }

    return {
        setTokenAuthData,
        clearUserAuthData,
        setAdminProfile
    }
}

export default useUserDispatcher